import { render, staticRenderFns } from "./BsListTileLeading.vue?vue&type=template&id=8bdf5330&scoped=true&"
import script from "./BsListTileLeading.vue?vue&type=script&lang=js&"
export * from "./BsListTileLeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bdf5330",
  null
  
)

export default component.exports